import { createContext, useContext } from 'react';
/**
 * Composer root width, in CSS pixels, below which attribution controls switch to their compact
 * presentation. At or above it, a leading mode control, a full model label, and the primary action
 * share one row. This matches the `composer-chin` container breakpoint for action labels.
 */
export const COMPOSER_NARROW_WIDTH_PX = 480;
/**
 * Whether the enclosing Composer is narrower than {@link COMPOSER_NARROW_WIDTH_PX}. The value
 * follows the composer's own rendered width, not the viewport, so an embedded or split-pane
 * composer at a desktop viewport can be narrow. It is `false` outside a Composer.
 */
export const ComposerWidthContext = createContext(false);
ComposerWidthContext.displayName = 'ComposerWidthContext';
/**
 * Reports whether the enclosing Composer is narrower than {@link COMPOSER_NARROW_WIDTH_PX}.
 * Slot content uses it to choose a compact presentation that preserves its accessible name and
 * behavior. Returns `false` outside a Composer.
 */
export function useIsComposerNarrow() {
    return useContext(ComposerWidthContext);
}
//# sourceMappingURL=ComposerWidthContext.js.map